const header = {
  header: {
    logOut: 'Esci',
    enphaseStore: 'Negozio Enphase',
    enphaseSupport: 'Supporto Enphase ',
    comingSoon: 'Disponibile prossimamente',
    new: 'Nuovo'
  }
};

export default header;
